import { combineReducers } from '@reduxjs/toolkit';
import exampleReducer from './slices/exampleSlice';
import securityReducer from './slices/securitySlice';
import loaderReducer from './slices/loaderSlice';
import modalAlertReducer from './slices/modalAlertSlice';
import unitsReducer from './slices//unitsSlice';
import measurementReducer from './slices/measurementsSlice';
import modelFileReducer from './slices/modelFileSlice.ts';
import digitalTwinReducer from './slices//digitalTwinSlice.ts';
import locationsReducer from './slices/locationsSlice.ts';
import readingsResumeSlice from './slices/readingsResumesSlice.ts';
import activitiesReducer from './slices/activitiesSlice.ts';
import interactiveSimulationSlice from './slices/interactiveSimulationSlice.ts';
import mapslice from './slices/mapSlice.ts';
import kpiSlice from './slices/kpiSlice.ts';
import organizationSlice from './slices/organizationSlice.ts';
import dashboardSlice from './slices/dashboardSlice.ts';
import typesWithUnitsReducer from './slices/measurementTypesWithUnitsSlice';

const rootReducer = combineReducers({
  example: exampleReducer,
  security: securityReducer,
  loader: loaderReducer,
  modalAlert: modalAlertReducer,
  units: unitsReducer,
  types: measurementReducer,
  modelFile: modelFileReducer,
  digitalTwin: digitalTwinReducer,
  locations: locationsReducer,
  readingsResumes: readingsResumeSlice,
  activities: activitiesReducer,
  interactiveSimulation: interactiveSimulationSlice,
  maps: mapslice,
  kpi: kpiSlice,
  organization: organizationSlice,
  dashboard: dashboardSlice,
  typesWithUnits: typesWithUnitsReducer,
});

export default rootReducer;
